<template>
	<v-tabs 
		class="round-card"
		height="34"
		background-color="background-1"
		slider-color="primary">
		<v-tab key="Campi" ripple class="secondary-tab">
			Campi
		</v-tab>
        <v-tab key="Stampa" ripple class="secondary-tab">
			Altro
		</v-tab>

		<v-tab-item class="pb-offset background-1 pt-3" key="Campi">
			<v-row class="ma-0 pb-offset">

				<v-col class="pa-0 pt-2" cols="12">
					<fields-selector model-def="intent"></fields-selector>
				</v-col>   
            
			</v-row>
		</v-tab-item>

		<v-tab-item class="pb-offset background-1 pt-3" key="Altro">
			<v-row class="ma-0 pb-offset">
				<v-col class="pa-0" cols="12">
					<v-card class="mb-2 background-2 round-card" ref="notificationssetting">
						<v-card-title class="pa-3">
							<p class="pl-2 pl-xl-3">Impostazioni</p>
							<v-spacer></v-spacer>
						</v-card-title> 
						<v-divider></v-divider>

						
						<v-subheader class="pl-4">Lettere di Intento</v-subheader>
						<v-list two-line subheader class="background-2 pa-2">
							<v-list-item>
								<v-list-item-action>
									<v-checkbox 
									color="primary" 
									hide-details
									v-model="settings['enable_intent']"></v-checkbox>
								</v-list-item-action>
								<v-list-item-content>
									<v-list-item-title>Abilita Lettere di Intento</v-list-item-title>
									<v-list-item-subtitle>Attiva o Disattiva l'utilizzo di plafond definiti nelle Lettere di Intento
									</v-list-item-subtitle>
								</v-list-item-content>
							</v-list-item>
						</v-list>

						<v-divider></v-divider>
						<v-card-actions>
							<v-spacer></v-spacer>
							<v-btn text class="pa-2 mx-2" color="primary" @click.native="saveSettings">Salva</v-btn>
						</v-card-actions>

					</v-card>
				</v-col>
    		</v-row>
		</v-tab-item>
	</v-tabs>
</template>
<script>
    
	import SettingsOptionsMixin from '@/mixins/SettingsOptionsMixin'
	import FieldsSelector from '@/components/common/FieldsSelector'

    export default {
        name: 'intents-settings',
		components: {
			FieldsSelector
		},
		mixins: [SettingsOptionsMixin],
        data() {
            return {
                model: 'document',
                settings: {
                    'enable_intent': false,
                },
            }
        },

        mounted() {
            this.$store.commit('endProgress')
        }
    }
</script>